import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

const ProtectedRoute = ({ children, requiredRole = null }) => {
    const { isAuthenticated, user } = useAuthStore();
    const location = useLocation();

    if (!isAuthenticated) {
        // Redirect to login page with return url
        return (
            <Navigate
                to="/login"
                state={{ from: location }}
                replace
            />
        );
    }

    // Check if user has required role using new boolean role system
    if (requiredRole && user) {
        const rolesFromUser = Array.isArray(user.roles)
            ? user.roles.map(r => r.toUpperCase())
            : [];

        const hasFlag = (flag) => {
            const cap = flag.charAt(0).toUpperCase() + flag.slice(1);
            return Boolean(user[flag] || user[`is${cap}`]);
        };

        const hasRequiredRole = (role) => {
            const roleName = role.toUpperCase();
            if (rolesFromUser.includes(roleName)) return true;

            switch (roleName) {
                case 'ADMIN':
                    return hasFlag('admin');
                case 'PLANNER':
                    return hasFlag('planner');
                case 'PROMOTER':
                    return hasFlag('promoter');
                case 'STAFF':
                    return hasFlag('staff');
                case 'BUYER':
                    return hasFlag('buyer');
                case 'SALE_AGENT':
                    return hasFlag('saleAgent');
                default:
                    return false;
            }
        };

        // Handle array of roles (user needs any one of them)
        if (Array.isArray(requiredRole)) {
            const hasAnyRole = requiredRole.some(role => hasRequiredRole(role));
            if (!hasAnyRole) {
                return <Navigate to="/" replace />;
            }
        }
        // Handle single role
        else if (!hasRequiredRole(requiredRole)) {
            return <Navigate to="/" replace />;
        }
    }

    return children;
};

export default ProtectedRoute; 
